"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ModalTrigger = void 0;
const react_1 = __importDefault(require("react"));
const react_aria_1 = require("react-aria");
const react_stately_1 = require("react-stately");
const clsx_1 = __importDefault(require("clsx"));
const Modal_1 = require("./Modal");
const ModalOpeningButton_1 = require("./ModalOpeningButton");
function ModalTrigger({ label, labelClasses, showLabel, containerClasses, icon, isDisabled, children, scope, ...props }) {
    const state = (0, react_stately_1.useOverlayTriggerState)(props);
    const { triggerProps, overlayProps } = (0, react_aria_1.useOverlayTrigger)({ type: 'dialog' }, state);
    let ariaAttr = {};
    if (!showLabel) {
        ariaAttr = { ...ariaAttr, 'aria-label': label };
    }
    return (react_1.default.createElement("div", { className: scope },
        react_1.default.createElement(ModalOpeningButton_1.ModalOpeningButton, { type: "button", title: label, ...triggerProps, ...ariaAttr, isDisabled: isDisabled, className: (0, clsx_1.default)(`${containerClasses ||
                'flex p-1 px-1.5 rounded mr-auto text-blue-300 hover:bg-blue-100 focus:bg-blue-100 focus:outline-none'}`, isDisabled && 'hover:bg-transparent cursor-not-allowed text-gray-600') },
            icon,
            showLabel && react_1.default.createElement("span", { className: `${labelClasses || 'ml-1 text-sm font-semibold leading-4'}` }, label)),
        state.isOpen && (react_1.default.createElement(Modal_1.Modal, { isDismissable: true, state: state, overlayProps: overlayProps, scope: scope }, (titleProps) => children(state.close, titleProps)))));
}
exports.ModalTrigger = ModalTrigger;
